module.exports = __webpack_public_path__ + "img/upload.8f43346b.svg";